// central configuration exported from environment variables
// React apps must prefix env vars with REACT_APP_

export const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production'
	? 'https://neuroapi.cjgames.it'
	: 'http://localhost:3939');

export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || (process.env.NODE_ENV === 'production'
	? 'https://neutraining.cjgames.it'
	: 'http://localhost:3000');
